export default __webpack_public_path__ + "static/media/facebook.10ac92c1.svg";